<template>
    <div class="model-wrap led">
        <div class="info-title">
            <span class="icon icon-info-title"></span>
            <div class="text">
                <span><tv k="l1"/></span>
                <span class="sub-text"><tv k="l2"/></span>
            </div>
            <span class="status ok"><tv k="l3"/></span>
        </div>
        <div class="model-line-bg"></div>
        <div class="model-content">
            <div class="setting1">
                <div class="name"><tv k="l4"/></div>
                <div class="blocks">
                    <div class="block"><tv k="l5"/></div>
                    <div class="block active"><tv k="l6"/></div>
                    <div class="block"><tv k="l7"/></div>
                    <div class="block"><tv k="l8"/></div>
                    <div class="block"><tv k="l9"/></div>
                    <div class="block"><tv k="l10"/></div>
                    <div class="block"><tv k="l11"/></div>
                    <div class="block"><tv k="l12"/></div>
        </div>
            </div>
            <div class="line"></div>
            <div class="setting2">
                <span class="name"><tv k="l13"/></span>
                <v-switch :val.sync="open"></v-switch>
            </div>
            <div class="line" style="margin-top: 19px"></div>
            <div class="ctl-wrap">
                <button class="btn btn-blue btn-full"><tv k="l14"/></button>
            </div>
        </div>
    </div>
</template>

<script>
    import VSwitch from '@/components/Switch.vue';

    export default {
        name: "PlayerModel",
        components: {VSwitch},
        data() {
            return {
                open: false
            }
        }
    }
</script>

<style lang="less">
    .led {
        .model-content {
            display: flex;
            flex-direction: column;

            .line{
                margin-top: 0;
            }

            .setting1 {

                .name {
                    font-size: 18px;
                    letter-spacing: 0px;
                    color: #32c5ff;
                    padding: 10px;
                }

                .blocks {
                    padding: 10px 0 10px 10px;
                    display: flex;
                    flex-wrap: wrap;

                    .block {
                        cursor: pointer;
                        margin-bottom: 15px;
                        border: 1px solid #32c5ff;
                        width: 22%;
                        font-size: 18px;
                        letter-spacing: 0px;
                        color: #32c5ff;
                        margin-right: 10px;
                        height: 59px;
                        line-height: 59px;
                        text-align: center;

                        &.active {
                            color: #ffffff;
                            background-color: #32c5ff;
                        }
                    }
                }
            }

            .setting2 {
                display: flex;
                align-items: center;
                justify-content: space-around;

                .name {
                    font-size: 18px;
                    letter-spacing: 0px;
                    color: #32c5ff;
                }

            }

            .ctl-wrap{
                margin-top: 10px;
                padding: 10px;
            }
        }
    }

</style>
